import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { ValidatedTextInput } from '@els/els-react--text-input';

export default function GroupOfMoreInput(props) {
  const { id, option, groupId, optionId, onChangeInput, disableIncludeAndMoreGroup } = props;
  const inputRef = React.useRef(null);
  const optionTitle = option.get('title');
  const title = typeof optionTitle === 'string' ? optionTitle.replace(/^# of /, 'Number of ') : optionTitle;
  const inputValue = option.get('inputValue');
  const isInputEmpty = !inputValue;
  const clearInputIcon = isInputEmpty
    ? undefined
    : {
        id: `group-of-more-input-clear-${optionId}`,
        sprite: 'Close',
        children: `Clear ${title} input`,
        a11y: { name: `Clear ${title} input` },
      };
  const handleClearInput = isInputEmpty
    ? undefined
    : () => {
        onChangeInput(id, groupId, optionId, '');
        inputRef.current?.focus();
      };

  return (
    <ValidatedTextInput
      data-e2e="group-of-more-input"
      inputRef={inputRef}
      className="group-of-more-input"
      disabled={disableIncludeAndMoreGroup}
      iconRight={clearInputIcon}
      iconRightCallback={handleClearInput}
      label={title}
      validator="none"
      onChange={(event) => {
        onChangeInput(id, groupId, optionId, event?.target?.value);
      }}
      value={inputValue}>
      {null}
    </ValidatedTextInput>
  );
}

GroupOfMoreInput.propTypes = {
  id: PropTypes.string.isRequired,
  option: PropTypes.instanceOf(Map),
  groupId: PropTypes.string.isRequired,
  optionId: PropTypes.string.isRequired,
  onChangeInput: PropTypes.func.isRequired,
  disableIncludeAndMoreGroup: PropTypes.bool.isRequired,
};
